import type { ReactNode } from "react";
import { Link } from "react-router-dom";

type LegalLayoutProps = {
  children: ReactNode;
  title: string;
};

export function LegalLayout({ children, title }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-black font-body-lp text-on-surface">
      <header className="border-b border-white/10">
        <div className="mx-auto max-w-4xl px-4 py-4 md:px-6">
          <Link className="text-sm text-white/60 transition-colors hover:text-white" to="/">
            &larr; TOPに戻る
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <h1 className="text-2xl font-bold text-white md:text-3xl">{title}</h1>
        <article className="prose prose-invert mt-8 max-w-none prose-headings:text-white prose-p:text-on-surface-variant prose-li:text-on-surface-variant prose-strong:text-white">
          {children}
        </article>
      </main>
      <footer className="border-t border-white/10">
        <div className="mx-auto max-w-4xl px-4 py-8 md:px-6">
          <nav className="flex flex-wrap gap-6">
            <Link
              className="text-sm text-white/40 transition-colors hover:text-white"
              to="/privacy-policy"
            >
              プライバシーポリシー
            </Link>
            <Link className="text-sm text-white/40 transition-colors hover:text-white" to="/terms">
              利用規約
            </Link>
            <Link
              className="text-sm text-white/40 transition-colors hover:text-white"
              to="/tokushoho"
            >
              特定商取引法に基づく表記
            </Link>
            <Link
              className="text-sm text-white/40 transition-colors hover:text-white"
              to="/support"
            >
              お問い合わせ
            </Link>
          </nav>
          <p className="mt-4 text-sm text-white/30">&copy; 2026 スカウトメールAI</p>
        </div>
      </footer>
    </div>
  );
}
